module.exports = __webpack_public_path__ + "img/answer-img1.eb8a8513.png";